import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { ReactComponent as Sun } from '../../images/sun.svg';
import { ReactComponent as DarkSun } from '../../images/dark-sun.svg';
import { Button } from '@mui/material';
import useUnmount from '../hooks/use_unmount';

const PROCESSING_ICONS = {
  darkSun: <DarkSun className="dark-sun-icon icon" />,
  sun: <Sun name="sun" className="sun-icon icon" />,
};

const BeamButton = ({
  variant = 'contained',
  shape = 'round',
  loadIcon = 'sun',
  useInternalProcessing,
  processing,
  onClick,
  sx,
  className,
  children,
  ...others
}) => {
  const [internalProcessing, setInternalProcessing] = useState(false);
  const effectiveProcessing = processing || internalProcessing;

  // to prevent state updates to processing var after a button unmounts
  const isMounted = useRef(true);
  useUnmount(() => {
    isMounted.current = false;
  });

  let sxOverride = sx;
  let colorOverride = 'primary';
  let effectiveVariant = variant;

  if (variant === 'link') {
    effectiveVariant = 'text';
    colorOverride = 'spruceBlue';
    sxOverride = {
      ...sxOverride,
      textTransform: 'none',
      textDecoration: 'underline',
      fontWeight: 'normal',
      fontSize: '14px',
      padding: '0px',
      '&.MuiButtonBase-root:hover': {
        bgcolor: 'transparent',
      },
    };
  }

  if (shape === 'round') {
    sxOverride = {
      ...sxOverride,
      '&.MuiButtonBase-root': {
        borderRadius: '50px',
      },
    };
  }

  const handleClick = async (e) => {
    if (useInternalProcessing) setInternalProcessing(true);
    if (effectiveProcessing) {
      e.preventDefault();
    } else if (typeof onClick === 'function') {
      await onClick(e);
    }
    if (useInternalProcessing && isMounted.current) setInternalProcessing(false);
  };

  return (
    <Button
      onClick={handleClick}
      sx={sxOverride}
      color={colorOverride}
      variant={effectiveVariant}
      className={`beam-button ${className}`}
      {...others}
    >
      {effectiveProcessing && <div className="sun-container">{PROCESSING_ICONS[loadIcon]}</div>}
      <div className="children-container" style={{ visibility: effectiveProcessing ? 'hidden' : '' }}>
        {children}
      </div>
    </Button>
  );
};

BeamButton.propTypes = {
  shape: PropTypes.oneOf(['round', 'square']),
  variant: PropTypes.oneOf(['contained', 'outlined', 'text', 'link']),
  loadIcon: PropTypes.oneOf(['sun', 'darkSun']),
  processing: PropTypes.bool,
  useInternalProcessing: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default BeamButton;
